/* Loumi Baby – ürün sayfası (sections/loumi-product.liquid).
   Renk/beden seçimi, renge göre galeri, fiyat/taksit, beden tablosu + bedenimi bul,
   kargo geri sayımı, birlikte al, mobil yapışkan buton. window.LM (loumi.js) kullanır. */
(function () {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (c) => (window.LM ? window.LM.money(c) : (c / 100).toFixed(2));
  const toast = (m) => window.LM && window.LM.toast(m);
  const sized = (url, w) => (url ? (/[?&]width=\d+/.test(url) ? url.replace(/([?&]width=)\d+/, '$1' + w) : url + (url.includes('?') ? '&' : '?') + 'width=' + w) : '');
  const num = (v) => { const n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? null : n; };
  function range(text) {
    if (!text) return [null, null];
    const parts = String(text).split(/\s*[–—-]\s*/).map(num).filter((n) => n !== null);
    return parts.length ? [parts[0], parts[parts.length - 1]] : [null, null];
  }

  function init(root) {
    if (root.dataset.lmReady) return;
    root.dataset.lmReady = '1';
    root.classList.add('is-js');
    let D;
    try { D = JSON.parse($('[data-lm-p-data]', root).textContent); } catch (e) { return; }
    const ci = D.colorIdx, si = D.sizeIdx;
    const label = (v) => (v == null ? '' : D.labels[String(v).trim()] || v);
    const state = { color: D.initColor || null, size: D.initSize || null, qty: 1 };

    /* ---------- varyantlar ---------- */
    const matchColor = (v) => ci < 0 || v.o[ci] === state.color;
    function chosen() {
      if (si > -1 && !state.size) return null;
      return D.variants.find((v) => matchColor(v) && (si < 0 || v.o[si] === state.size)) || null;
    }
    function display() {
      return chosen() || D.variants.find((v) => matchColor(v) && v.a) || D.variants.find(matchColor) || D.variants[0];
    }

    /* ---------- galeri ---------- */
    const slides = $('[data-lm-slides]', root);
    const thumbs = $('[data-lm-thumbs]', root);
    const dots = $('[data-lm-dots]', root);
    // galeri ekrandan uzunsa alt kenarı görünene kadar kayar, sonra sabitlenir
    const gal = $('.lm-p-gallery', root);
    function galTop() {
      if (!gal) return;
      const hh = parseFloat(getComputedStyle(document.body).getPropertyValue('--lm-header-h')) || 0;
      gal.style.setProperty('--lm-gal-top', Math.min(hh + 8, window.innerHeight - gal.offsetHeight - 8) + 'px');
    }
    if (gal) {
      galTop();
      window.addEventListener('resize', galTop, { passive: true });
      window.addEventListener('load', galTop);
      if ('ResizeObserver' in window) new ResizeObserver(galTop).observe(gal);
    }
    const groups = {};
    (function buildGroups() {
      if (ci < 0) return;
      const startOf = {};
      const seen = new Set();
      D.variants.forEach((v) => {
        const c = v.o[ci];
        if (seen.has(c) || !v.m) return;
        seen.add(c);
        (startOf[v.m] = startOf[v.m] || []).push(c);
      });
      let cur = [];
      D.media.forEach((m) => {
        if (startOf[m.id]) cur = startOf[m.id];
        cur.forEach((c) => (groups[c] = groups[c] || []).push(m));
      });
    })();
    const mediaFor = (c) => (groups[c] && groups[c].length ? groups[c] : D.media);

    function paintGallery() {
      if (!slides || !D.media.length) return;
      const list = mediaFor(state.color);
      const sizes = '(min-width: 1440px) 880px, (min-width: 961px) 62vw, 100vw';
      slides.innerHTML = list.map((m, i) => {
        const set = [400, 600, 800, 1000, 1200, 1400].map((w) => `${sized(m.src, w)} ${w}w`).join(', ');
        return `<div class="lm-p-slide"><img src="${esc(sized(m.src, 1000))}" srcset="${esc(set)}" sizes="${sizes}" alt="${esc(m.alt)}" width="1000" height="${Math.round(1000 / (m.r || 1))}" ${i ? 'loading="lazy"' : ''}></div>`;
      }).join('');
      if (thumbs) thumbs.innerHTML = list.map((m, i) => `<button type="button" class="lm-p-thumb${i ? '' : ' is-on'}" data-i="${i}" aria-label="Görsel ${i + 1}"><img src="${esc(m.th)}" alt="" width="100" height="100" loading="lazy"></button>`).join('');
      if (dots) dots.innerHTML = list.map((_, i) => `<i class="${i ? '' : 'is-on'}"></i>`).join('');
      slides.scrollLeft = 0;
      dots && (dots.hidden = list.length < 2);
      $$('[data-lm-prev], [data-lm-next]', root).forEach((b) => { b.hidden = list.length < 2; });
      const st = $('.lm-p-sticky img', root);
      if (st && list[0]) { st.src = sized(list[0].th, 120); st.removeAttribute('srcset'); }
    }
    if (dots) dots.hidden = $$('.lm-p-slide', slides || root).length < 2;
    function goSlide(i) { slides && slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' }); }
    let raf;
    slides && slides.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
        $$('.lm-p-thumb', root).forEach((b, k) => b.classList.toggle('is-on', k === i));
        dots && $$('i', dots).forEach((d, k) => d.classList.toggle('is-on', k === i));
      });
    }, { passive: true });
    slides && slides.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      const i = Math.round(slides.scrollLeft / slides.clientWidth) + (e.key === 'ArrowRight' ? 1 : -1);
      goSlide(Math.max(0, i));
    });
    $$('[data-lm-prev], [data-lm-next]', root).forEach((b) => b.addEventListener('click', () => {
      const last = $$('.lm-p-slide', slides).length - 1;
      let i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)) + (b.hasAttribute('data-lm-next') ? 1 : -1);
      if (i > last) i = 0; else if (i < 0) i = last;
      goSlide(i);
    }));

    /* ---------- ekran güncelleme ---------- */
    const sizeErr = $('[data-lm-size-err]', root);
    const idSel = $('[data-lm-id]', root);
    const atc = $('[data-lm-atc]', root);
    function paintSizes() {
      $$('[data-lm-size]', root).forEach((b) => {
        const val = b.dataset.lmSize;
        const v = D.variants.find((x) => matchColor(x) && x.o[si] === val);
        const ok = !!(v && v.a);
        b.disabled = !ok;
        const on = state.size === val;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        const low = $('.lm-p-size__low', b);
        if (low) {
          const n = ok && v.q != null && v.q > 0 && v.q <= D.lowAt ? v.q : 0;
          low.hidden = !n;
          low.textContent = n ? `Son ${n}` : '';
        }
      });
      const nm = $('[data-lm-size-name]', root);
      if (nm) nm.textContent = state.size ? label(state.size) : 'Seçiniz';
    }
    function variantText() {
      const parts = [];
      if (si > -1) parts.push(state.size ? label(state.size) : 'Beden seçin');
      if (ci > -1 && state.color) parts.push(state.color);
      return parts.join(' · ');
    }
    function paint() {
      const v = display();
      const sel = chosen();
      const price = v.p;
      $('[data-lm-price]', root).textContent = money(price);
      const cmp = $('[data-lm-compare]', root), sale = $('[data-lm-sale]', root);
      const onSale = v.c > v.p;
      if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? money(v.c) : ''; }
      if (sale) { sale.hidden = !onSale; sale.textContent = onSale ? `-%${Math.floor(((v.c - v.p) * 100) / v.c)}` : ''; }
      const inst = $('[data-lm-inst-amount]', root);
      if (inst && D.inst > 1) inst.textContent = money(Math.round(price / D.inst));
      $$('[data-lm-sku-row]', root).forEach((r) => (r.hidden = !v.s));
      const sku = $('[data-lm-sku]', root); if (sku) sku.textContent = v.s || '';
      if (idSel) idSel.value = String(v.id);

      // sepete ekle düğmesi
      const anyAvail = D.variants.some((x) => matchColor(x) && x.a);
      const soldOut = sel ? !sel.a : !anyAvail;
      if (atc) {
        atc.disabled = soldOut;
        $('[data-lm-atc-label]', atc).textContent = soldOut ? 'Tükendi' : 'Sepete ekle';
        const sep = $('[data-lm-atc-sep]', atc), pr = $('[data-lm-atc-price]', atc);
        sep.hidden = pr.hidden = soldOut;
        pr.textContent = money(price * state.qty);
      }
      const sp = $('[data-lm-sticky-price]', root); if (sp) sp.textContent = money(price);
      const sv = $('[data-lm-sticky-var]', root); if (sv) sv.textContent = variantText();
      const sb = $('[data-lm-sticky-btn]', root);
      if (sb) { sb.disabled = soldOut; sb.textContent = soldOut ? 'Tükendi' : 'Sepete ekle'; }
      paintBundle();
    }
    function syncUrl() {
      const v = display();
      if (!v || !window.history.replaceState) return;
      const u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    }

    function pickColor(c) {
      if (c === state.color) return;
      state.color = c;
      $$('[data-lm-color]', root).forEach((b) => {
        const on = b.dataset.lmColor === c;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      const nm = $('[data-lm-color-name]', root); if (nm) nm.textContent = c;
      if (state.size && !D.variants.some((v) => matchColor(v) && v.o[si] === state.size && v.a) && D.needSize) state.size = null;
      paintGallery(); paintSizes(); paint(); syncUrl();
    }
    function pickSize(s) {
      state.size = s;
      if (sizeErr) sizeErr.hidden = true;
      root.classList.remove('has-size-err');
      paintSizes(); paint(); syncUrl();
    }
    function sizeMissing() {
      if (sizeErr) sizeErr.hidden = false;
      root.classList.add('has-size-err');
      const box = $('[data-lm-sizes]', root);
      box && box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      toast('Lütfen önce beden seçin');
    }

    /* ---------- sepete ekle ---------- */
    const form = $('.lm-p-form', root);
    async function addMain(btn) {
      if (D.needSize && !state.size) { sizeMissing(); return; }
      const v = chosen() || display();
      if (!v || !v.a) { toast('Bu seçenek tükendi'); return; }
      if (!window.LM) { form && form.submit(); return; }
      [atc, $('[data-lm-sticky-btn]', root)].forEach((b) => b && b.classList.add('is-loading'));
      try { await window.LM.cart.add([{ id: v.id, quantity: state.qty }], { open: true }); }
      finally { [atc, $('[data-lm-sticky-btn]', root)].forEach((b) => b && b.classList.remove('is-loading')); }
    }
    form && form.addEventListener('submit', (e) => { if (!window.LM) return; e.preventDefault(); addMain(); });

    const qtyIn = $('[data-lm-qty-input]', root);
    function setQty(n) {
      state.qty = Math.min(99, Math.max(1, parseInt(n, 10) || 1));
      if (qtyIn) qtyIn.value = state.qty;
      paint();
    }
    qtyIn && qtyIn.addEventListener('change', () => setQty(qtyIn.value));

    /* ---------- beden tablosu + bedenimi bul ---------- */
    const rows = (D.rows || []).map((r) => {
      const h = range(r.h), w = range(r.w);
      const vs = String(r.v || '').split(',').map((x) => x.trim()).filter(Boolean);
      return { vs, v: vs[0], l: r.l, hmin: num(r.hmin) ?? h[0], hmax: num(r.hmax) ?? h[1], wmin: num(r.wmin) ?? w[0], wmax: num(r.wmax) ?? w[1] };
    }).filter((r) => r.hmax != null || r.wmax != null);
    const productSizes = new Set(D.variants.map((v) => (si > -1 ? v.o[si] : null)));
    const inProduct = (r) => r.vs.find((x) => productSizes.has(x));
    rows.forEach((r) => { const p = inProduct(r); if (p) r.v = p; });
    const fRows = rows.some(inProduct) ? rows.filter(inProduct) : rows;
    const chartId = 'lm-p-chart-' + root.dataset.section, finderId = 'lm-p-finder-' + root.dataset.section;
    const chart = document.getElementById(chartId), finder = document.getElementById(finderId);
    let pref = 0, rec = null;
    function highlight(val) { chart && $$('tr[data-v]', chart).forEach((r) => r.classList.toggle('is-hl', !!val && r.dataset.v.split(',').map((x) => x.trim()).includes(val))); }
    function initFinder() {
      if (!finder || !fRows.length) return;
      const hs = fRows.flatMap((r) => [r.hmin, r.hmax]).filter((n) => n != null);
      const ws = fRows.flatMap((r) => [r.wmin, r.wmax]).filter((n) => n != null);
      const H = $('[data-lm-f-h]', finder), W = $('[data-lm-f-w]', finder);
      if (hs.length) { H.min = Math.floor(Math.min(...hs) - 4); H.max = Math.ceil(Math.max(...hs) + 2); H.value = Math.round((+H.min + +H.max) / 2); }
      if (ws.length) { W.min = Math.max(1, Math.floor(Math.min(...ws) - 1)); W.max = Math.ceil(Math.max(...ws) + 1); W.value = Math.round((+W.min + +W.max) / 2 * 2) / 2; }
    }
    function calc() {
      if (!finder || !fRows.length) return;
      const h = +$('[data-lm-f-h]', finder).value, w = +$('[data-lm-f-w]', finder).value;
      const fw = String(w).replace('.', ',');
      $('[data-lm-fv-h]', finder).textContent = h + ' cm';
      $('[data-lm-fv-w]', finder).textContent = fw + ' kg';
      const last = fRows.length - 1;
      const idx = (val, key) => { const i = fRows.findIndex((r) => r[key] != null && val < r[key]); return i < 0 ? last : i; };
      let i = Math.max(idx(h, 'hmax'), idx(w, 'wmax'));
      if (pref) i = Math.min(last, i + 1);
      rec = fRows[i];
      $('[data-lm-f-rec]', finder).textContent = rec.l || label(rec.v);
      $('[data-lm-f-why]', finder).textContent = `${h} cm ve ${fw} kg için${pref ? ', bol kullanım tercihiyle' : ''}`;
      const v = D.variants.find((x) => matchColor(x) && x.o[si] === rec.v);
      const btn = $('[data-lm-f-apply]', finder);
      btn.disabled = !(v && v.a);
      btn.textContent = !v ? 'Bu ürünün bu bedeni yok' : v.a ? 'Bu bedeni seç' : 'Bu beden tükendi';
      highlight(rec.v);
    }
    initFinder();
    if (finder) {
      $$('input[type=range]', finder).forEach((r) => r.addEventListener('input', calc));
      $('[data-lm-f-pref]', finder).addEventListener('click', (e) => {
        const b = e.target.closest('button'); if (!b) return;
        pref = +b.dataset.p;
        $$('[data-lm-f-pref] button', finder).forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        calc();
      });
      $('[data-lm-f-apply]', finder).addEventListener('click', () => {
        if (!rec) return;
        pickSize(rec.v);
        window.LM && window.LM.closeAll();
        toast(`${rec.l || label(rec.v)} seçildi`);
      });
    }

    /* ---------- tıklamalar ---------- */
    root.addEventListener('click', (e) => {
      const t = e.target;
      let el;
      if ((el = t.closest('[data-lm-color]'))) { pickColor(el.dataset.lmColor); return; }
      if ((el = t.closest('[data-lm-size]'))) { if (!el.disabled) pickSize(el.dataset.lmSize); return; }
      if ((el = t.closest('.lm-p-thumb'))) { goSlide(+el.dataset.i); return; }
      if ((el = t.closest('[data-lm-qty]'))) { setQty(state.qty + +el.dataset.lmQty); return; }
      if ((el = t.closest('[data-lm-sticky-btn]'))) { addMain(el); return; }
      if (t.closest('[data-lm-open-finder]')) { setTimeout(calc, 0); return; }
      if (t.closest('[data-lm-open-chart]')) { highlight(state.size); return; }
    });

    /* ---------- kargo geri sayımı ---------- */
    const ship = $('[data-lm-ship]', root);
    function tick() {
      if (!ship || !window.LM || !window.LM.delivery) return;
      const d = window.LM.delivery();
      $('[data-lm-countdown]', ship).innerHTML = d.today
        ? `<b>${d.hours} sa ${d.minutes} dk</b> içinde sipariş verirseniz <b>bugün kargoda</b>`
        : `Şimdi sipariş verirseniz <b>${esc(d.fmt(d.ship))}</b> kargoda`;
      $('[data-lm-d-ship]', ship).textContent = d.today ? 'Bugün' : d.fmt(d.ship);
      $('[data-lm-d-to]', ship).textContent = `${d.fmt(d.from)} – ${d.fmt(d.to)}`;
      ship.hidden = false;
    }
    if (ship) { tick(); if (window.LM) setInterval(tick, 30000); }

    /* ---------- birlikte iyi gider ---------- */
    const bSec = $('[data-lm-bundle]', root);
    let addons = [];
    function optText(o) { return (o || []).filter((x) => x && x !== 'Default Title').map(label).join(' / '); }
    function renderBundle() {
      if (!bSec) return;
      if (!addons.length) { bSec.hidden = true; return; }
      const mainImg = (mediaFor(state.color)[0] || {}).th;
      const priceHtml = (p, c) => `${money(p)}${c > p ? ` <s>${money(c)}</s>` : ''}`;
      const main = `<div class="lm-p-bi" data-main>
        <span class="lm-p-bi__img">${mainImg ? `<img src="${esc(sized(mainImg, 400))}" alt="" loading="lazy" width="170" height="170">` : ''}</span>
        <label class="lm-p-bi__n"><input type="checkbox" checked data-lm-b-main><span><b>Bu ürün:</b> ${esc(D.title)}</span></label>
        <div class="lm-p-bi__p" data-lm-b-main-price></div></div>`;
      const items = addons.map((p, k) => {
        const avail = p.v.filter((v) => v.a);
        const sel = avail.length > 1
          ? `<select data-lm-b-var aria-label="${esc(p.t)} seçeneği">${avail.map((v) => `<option value="${v.id}" data-p="${v.p}" data-c="${v.c || 0}">${esc(optText(v.o) || p.t)}</option>`).join('')}</select>`
          : '';
        const first = avail[0];
        return `<span class="lm-p-bplus" aria-hidden="true">+</span><div class="lm-p-bi" data-k="${k}" data-id="${first.id}" data-p="${first.p}" data-c="${first.c || 0}">
          <a class="lm-p-bi__img" href="${esc(p.u)}" tabindex="-1">${p.img ? `<img src="${esc(sized(p.img, 400))}" alt="" loading="lazy" width="170" height="170">` : ''}</a>
          <label class="lm-p-bi__n"><input type="checkbox" checked data-lm-b-item><span>${esc(p.t)}</span></label>
          ${sel}<div class="lm-p-bi__p">${priceHtml(first.p, first.c || 0)}</div></div>`;
      }).join('');
      $('[data-lm-bundle-items]', bSec).innerHTML = main + items;
      $$('[data-lm-b-var]', bSec).forEach((s) => {
        const first = s.closest('.lm-p-bi').dataset.id; s.value = first;
      });
      bSec.hidden = false;
      paintBundle();
    }
    function paintBundle() {
      if (!bSec || bSec.hidden) return;
      const v = display();
      const mainOk = D.variants.some((x) => x.a);
      const mb = $('[data-lm-b-main]', bSec);
      if (mb) { mb.disabled = !mainOk; if (!mainOk) mb.checked = false; }
      const mp = $('[data-lm-b-main-price]', bSec); if (mp) mp.innerHTML = `${money(v.p)}${v.c > v.p ? ` <s>${money(v.c)}</s>` : ''}`;
      let count = 0, sum = 0, was = 0;
      if (mb && mb.checked) { count++; sum += v.p; was += Math.max(v.c || 0, v.p); }
      const mainBox = $('.lm-p-bi[data-main]', bSec); if (mainBox && mb) mainBox.classList.toggle('is-off', !mb.checked);
      $$('.lm-p-bi[data-k]', bSec).forEach((it) => {
        const on = $('[data-lm-b-item]', it).checked;
        it.classList.toggle('is-off', !on);
        if (on) { count++; sum += +it.dataset.p; was += Math.max(+it.dataset.c || 0, +it.dataset.p); }
      });
      $('[data-lm-bundle-count]', bSec).textContent = count;
      $('[data-lm-bundle-total]', bSec).textContent = money(sum);
      const old = $('[data-lm-bundle-old]', bSec);
      if (old) { old.hidden = was <= sum; old.textContent = was > sum ? money(was) : ''; }
      const hint = $('[data-lm-bundle-hint]', bSec);
      const multi = D.multi.on && count >= D.multi.min;
      const txt = multi ? D.multi.title : (was > sum ? `${money(was - sum)} tasarruf` : '');
      hint.hidden = !txt; hint.textContent = txt;
      $('[data-lm-bundle-add]', bSec).disabled = count === 0;
    }
    if (bSec) {
      bSec.addEventListener('change', (e) => {
        const s = e.target.closest('[data-lm-b-var]');
        if (s) {
          const it = s.closest('.lm-p-bi');
          const o = s.selectedOptions[0];
          it.dataset.id = s.value; it.dataset.p = o.dataset.p; it.dataset.c = o.dataset.c || 0;
          const c = +o.dataset.c || 0, p = +o.dataset.p;
          $('.lm-p-bi__p', it).innerHTML = `${money(p)}${c > p ? ` <s>${money(c)}</s>` : ''}`;
        }
        paintBundle();
      });
      $('[data-lm-bundle-add]', bSec).addEventListener('click', async (e) => {
        const items = [];
        const mb = $('[data-lm-b-main]', bSec);
        if (mb && mb.checked) {
          if (D.needSize && !state.size) { sizeMissing(); return; }
          const v = chosen() || display();
          if (!v.a) { toast('Bu seçenek tükendi'); return; }
          items.push({ id: v.id, quantity: 1 });
        }
        $$('.lm-p-bi[data-k]', bSec).forEach((it) => { if ($('[data-lm-b-item]', it).checked) items.push({ id: +it.dataset.id, quantity: 1 }); });
        if (!items.length || !window.LM) return;
        const b = e.currentTarget; b.classList.add('is-loading');
        try { await window.LM.cart.add(items, { open: true }); } finally { b.classList.remove('is-loading'); }
      });
      const ready = (list) => { addons = list.filter((p) => p.id !== D.id && p.v.some((v) => v.a)).slice(0, 2); renderBundle(); };
      if (D.addons && D.addons.length) ready(D.addons);
      else if (window.LM && window.LM.recs) window.LM.recs(D.id, { limit: 2, type: D.type }).then(ready);
    }

    /* ---------- mobil yapışkan buton ---------- */
    const sticky = $('[data-lm-sticky]', root);
    const anchor = $('[data-lm-atc-row]', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      const mq = window.matchMedia('(max-width: 960px)');
      let past = false;
      const set = () => {
        const on = past && mq.matches;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        const b = $('[data-lm-sticky-btn]', sticky); if (b) b.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('lm-has-sticky', on);
      };
      new IntersectionObserver(([en]) => { past = !en.isIntersecting && en.boundingClientRect.top < 0; set(); }).observe(anchor);
      mq.addEventListener ? mq.addEventListener('change', set) : mq.addListener(set);
    }

    paintSizes();
    paint();
  }

  const boot = () => $$('[data-lm-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
